export function evaluateConditions(conditions, fieldValues) {
  // null = always visible
  if (!conditions || !conditions.rules || !conditions.rules.length) return true;

  const normalizeArray = value => (Array.isArray(value) ? value : [value]);

  const results = conditions.rules.map(rule => {
    const actual = fieldValues[rule.field_key];
    switch (rule.operator) {
      case 'eq':
      case 'equals':
        return String(actual) === String(rule.value);
      case 'neq':
      case 'not_equals':
        return String(actual) !== String(rule.value);
      case 'in':
        return normalizeArray(rule.value).map(String).includes(String(actual));
      case 'not_in':
        return !normalizeArray(rule.value).map(String).includes(String(actual));
      case 'filled':
        return actual !== undefined && actual !== null && String(actual) !== '';
      case 'empty':
        return actual === undefined || actual === null || String(actual) === '';
      default:
        return false;
    }
  });

  return conditions.logic === 'OR'
    ? results.some(Boolean)
    : results.every(Boolean);
}

export default evaluateConditions;
